import { Header, Modal } from '@procurify/ui'

import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import { BudgetCategoryExporter } from './BudgetCategoryExporter'
import messages from './messages'

export interface BudgetCategoryExporterModalProps {
  open?: boolean
  onDismiss?(): void
}

export const BudgetCategoryExporterModal = ({
  open = false,
  onDismiss = () => undefined,
}: BudgetCategoryExporterModalProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  return (
    <Modal
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-categories-export-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-categories-export-modal-title'>
            {intl.formatMessage(
              FT_5817_ENABLE_BUDGETS_REDESIGN
                ? messages.budgetsExporterModalTitle
                : messages.budgetCategoryExporterModalTitle
            )}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryExporter handleModalClose={onDismiss} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
